import HttpClient, { axiosRetry } from '@adsk/docs-http-client';
import { DEFAULT_RETRY_TIMES, OSS_BASE_URL, OSS_ENVS, OSS_BASE_PATH, S3_URL_EXPIRED_DURATION } from './consts';
import { getSignedUrlPath, getBucketKeyFromObjectId, getObjectKeyFromObjectId } from './file';
const isOssRetryError = error => error && error.response && [400, 404, 408, 409, 429, 500, 503, 504].includes(error.response.status);
const DEFAULT_RETRY_CONFIG = {
  shouldResetTimeout: true,
  retries: DEFAULT_RETRY_TIMES,
  retryDelay: retryCount => Math.pow(retryCount, 3) * 1000,
  // 1s 8s 27s
  retryCondition: error => axiosRetry.isNetworkError(error) || axiosRetry.isSafeRequestError(error) || isOssRetryError(error)
};
export default config => {
  const ossBaseUrl = config.baseURL || OSS_BASE_URL[config.env || OSS_ENVS.STAGING];
  const Services = {
    OSS_V2: new HttpClient(Object.assign({}, config, {
      baseURL: `${ossBaseUrl}${OSS_BASE_PATH}`,
      withToken: config.getAccessToken ? true : false,
      getToken: config.getAccessToken,
      retryConfig: config.retryConfig || DEFAULT_RETRY_CONFIG
    })),
    AWS_S3: new HttpClient(Object.assign({}, config, {
      baseURL: '',
      withToken: false,
      retryConfig: config.retryConfig || DEFAULT_RETRY_CONFIG,
      // Disabled circuit breaker for AWS S3 by default
      circuitBreaker: {
        disabled: true
      }
    }))
  };
  const getSignedUrl = ({
    bucketKey,
    objectKey,
    uploadKey,
    firstPart
  }, options) => {
    const path = getSignedUrlPath({
      bucketKey,
      objectKey,
      uploadKey,
      firstPart,
      parts: 1,
      minutesExpiration: S3_URL_EXPIRED_DURATION
    }); // only get one part url
    return Services.OSS_V2.get(path, options);
  };
  const putToSignedUrl = (signedUrl, data, callback, options) => {
    return Services.AWS_S3.put(signedUrl, data, Object.assign({
      onUploadProgress: event => {
        callback({
          totalBytes: event.total,
          uploadedBytes: event.loaded
        });
      }
    }, options));
  };
  const completeUpload = ({
    bucketKey,
    objectKey,
    uploadKey
  }, options) => {
    const path = `/buckets/${bucketKey}/objects/${objectKey}/signeds3upload`;
    return Services.OSS_V2.post(path, {
      uploadKey
    }, options);
  };
  const deleteFile = (objectId, options) => {
    const bucketKey = getBucketKeyFromObjectId(objectId);
    const objectKey = getObjectKeyFromObjectId(objectId);
    const path = `/buckets/${bucketKey}/objects/${objectKey}`;
    return Services.OSS_V2.delete(path, options);
  };
  return {
    getSignedUrl,
    putToSignedUrl,
    completeUpload,
    deleteFile
  };
};